import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'zone.js';

import { AppModule } from './app/app.module';
import { env } from './environments/env';

// Disable Fullscreen API requests in non-production builds to avoid "Potential permissions policy violation: fullscreen is not allowed in this document." console messages.
if (!env.get().production) {
  try {
    const proto: any = (Element.prototype as any) || {};
    // Save originals if needed
    if (!proto.__origRequestFullscreen && typeof proto.requestFullscreen === 'function') {
      proto.__origRequestFullscreen = proto.requestFullscreen;
      proto.requestFullscreen = function () {
        // Silently swallow or log for debugging
        // Returning a resolved promise keeps callers from failing

        console.debug('[dev] requestFullscreen overridden to avoid permissions-policy console message');
        return Promise.resolve();
      };
    }
    // Also patch vendor-prefixed versions just in case
    const htmlProto: any = (HTMLElement.prototype as any) || {};
    if (!htmlProto.__origRequestFullscreen && typeof htmlProto.requestFullscreen === 'function') {
      htmlProto.__origRequestFullscreen = htmlProto.requestFullscreen;
      htmlProto.requestFullscreen = function () {
        console.debug('[dev] HTMLElement.requestFullscreen overridden');
        return Promise.resolve();
      };
    }
  } catch {
    // ignore; if this fails we don't want to block app startup
  }
}

if (env.get().production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
